import { StoreTypography } from '@/features/storefronts/_storeBase/typography/StoreTypography'

import styles from './Badge.module.scss'

type Props = {
  amount: number
}

export const Badge = ({ amount }: Props) => (
  <div className={styles.Container}>
    <div className={styles.Badge}>
      <StoreTypography tag="p" style="outlined" textSize="body" className={styles.Amount}>
        x{amount}
      </StoreTypography>
    </div>
  </div>
)
